<template>
  <component :is="resolved" />
</template>

<script>
import { mapState } from "vuex";
import Home from "./Home.vue";
import EbookHome from "./EbookHome.vue";

export default {
  name: "HomeRouter",
  computed: {
    ...mapState(["setup"]),
    resolved() {
      const isEbook = this.setup && this.setup.type_product === "ebook";
      return isEbook ? EbookHome : Home;
    }
  }
};
</script>
